<template>
    <div class="quillWrapper">
      <div ref="editor"></div>
    </div>
  </template>

  <script>
  import Quill from 'quill';
  import { linkifyUserInput, linkifyDocument, autoLinkPastedText } from '@/utils/richText/quillAutoLink';
  export default {
    name: 'QuillEditor',
    props: {
      value: {
        type: String,
        default: ''
      },
      options: {
        type: Object,
        default: () => ({})
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // ベタ書きの URL を入力時 / 貼り付け時に自動でリンクへ変換する。
      // 既存の呼び出し元の挙動を変えないため、既定では無効。
      autoLink: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        quill: null
      };
    },
    mounted() {
        this.initializeQuill();
    },
    beforeDestroy() {
      if (this.quill) {
        this.quill.off('text-change', this.handleTextChange);
        this.quill.off('selection-change', this.handleSelectionChange);
      }
    },
    methods: {
      initializeQuill() {
        const editorOptions = {
          theme: 'snow',
          modules: {
            toolbar: this.customToolbar || [
              [{ 'font': [] }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['bold', 'italic', 'underline', 'strike'],
              ['link', 'clean']
            ],
            ...this.options.modules
          },
          ...this.options,
          readOnly: this.disabled
        };
        this.quill = new Quill(this.$refs.editor, editorOptions);

        // matcher は既存内容の流し込みより先に登録し、初期表示にも同じ変換を効かせる。
        if (this.autoLink) {
          // text/html を含む貼り付けはここで Delta に直接リンクを載せる。貼り付けが
          // 1回の undo 単位に収まる。text/html が無い経路は matcher を通らないため、
          // text-change 側の linkifyUserInput が受け持つ。
          this.quill.clipboard.addMatcher(Node.TEXT_NODE, autoLinkPastedText);
          this.quill.on('selection-change', this.handleSelectionChange);
        }

        if (this.value) {
        this.quill.clipboard.dangerouslyPasteHTML(this.value);
      }

      this.quill.on('text-change', this.handleTextChange);
    },
    handleTextChange(delta, oldDelta, source) {
      // リンク化を先に済ませてから emit することで、親には変換後の HTML が渡る。
      if (this.autoLink && source === 'user') {
        linkifyUserInput(this.quill, delta);
      }
      const html = this.quill.root.innerHTML;
      const contents = this.quill.getContents();
      this.$emit('deltaChange', contents);
      this.$emit('input', html);
    },
    handleSelectionChange(range) {
      // range が null はフォーカスアウト。区切り文字を打たずに書き終えた URL を、
      // 保存前にこの時点で拾ってリンクにする。
      if (range === null) {
        linkifyDocument(this.quill);
      }
    }
  },

    watch: {
      value(newValue) {
        if (this.quill && newValue !== this.quill.root.innerHTML) {
          this.quill.root.innerHTML = newValue;
        }
      },
      disabled(newDisabled) {
        if (this.quill) {
          this.quill.enable(!newDisabled);
        }
      }
    }
  };
  </script>

  <style>
  .quillWrapper {
    min-height: 200px;
  }
  .ql-editor{
    min-height: 200px;
  }
  .ql-editor p {
    margin-bottom: 0;
    padding: 0;
  }
  </style>
